import Axios from "axios";
import classNames from "classnames";
import { formatISO } from "date-fns";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { ProgressBar } from "primereact/progressbar";
import { Tag } from "primereact/tag";
import { useEffect, useState } from "react";
import { BiRefresh } from "react-icons/bi";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import { Api, ApiAdimplencia, ApiZoop } from "../../../services/api";
import { CalendarPague, DropdownPague, FloatLabelCalendar, FloatLabelNumber, InputNumberPague } from "../../../styles/primeReactConfig";
import { getLocal, setLocal } from "../../../utils/localStorageOps";
import { validaCpf } from "../../../utils/validacoes";

function CadastroRepresentante() {

  const navigate = useNavigate();
  const regex = /[!@#$%^&()_={}\]:;,.<>+\/?0-9]/;
  const regexAdress = /[!@#$%^&()_={}\]:;,.<>+\/?]/;
  const CPF = getLocal('documentocadastro').length === 11;
  const [userID, setUserID] = useState(getLocal('usuario_id'));
  const [rendaMensal, setRendaMensal] = useState(0);
  const [documento, setDocumento] = useState();
  const [nome, setNome] = useState();
  const [nomeMae, setNomeMae] = useState();
  const [birthday, setBirthday] = useState();
  const [cep, setCep] = useState(getLocal('cepcadastro'));
  const [estado, setEstado] = useState('');
  const [city, setCity] = useState('');
  const [street, setStreet] = useState('');
  const [bairro, setBairro] = useState('');
  const [number, setNumber] = useState();
  const [complemento, setComplemento] = useState('');
  const [type, setType] = useState('AP');
  const [adress, setAdress] = useState(getLocal('usuario_id') ? true : false);
  const [loading, setLoading] = useState(false);
  const [atividadesOptions, setAtividadesOptions] = useState([{ label: '', value: null }]);
  const [atividades, setAtividades] = useState(null)
  const [reload, setReload] = useState(false)
  const today = new Date();
  const options = [
    { label: 'Associação Privada', value: 'AP' },
    { label: 'Micro empreendedor Individual', value: 'MEI' },
    { label: 'Empreendedor Individual', value: 'EI' },
    { label: 'Emp. Individual de Respons. Limitada', value: 'EIRELI' },
    { label: 'Sociedade Limitada', value: 'LTDA' },
    { label: 'Sociedade Anônima', value: 'SA' },
    { label: 'Instituição não governamental', value: 'INSTITUTION_NGO_ASSOCIATION' },
  ]

  useEffect(() => {
    //console.log(getLocal('cepcadastro'))
    if (getLocal('cepcadastro') !== null)
      consultaCEP(getLocal('cepcadastro'))
    consultaAtividade()
  }, [reload])

  const createUser = async () => {
    setLoading(true);
    const userData = {
      usuario_documento: getLocal('documentocadastro'),
      nome_fantasia: getLocal('nomefantasiacadastro'),
      usuario_email: getLocal('emailcadastro'),
      usuario_telefone: getLocal('telefonecadastro'),
      password: getLocal('passwordcadastro'),
      usuario_nome: getLocal('nomecadastro'),
      usuario_data_nascimento: getLocal('datacriacao'),
      renda_mensal: rendaMensal,
      usuario_provider: true,
      tipo_empresa: CPF ? '' : type,
      tipo_atividade_id: atividades,
      cartorio_provider: atividades === '9d8d3dcc-7fb0-4b42-9c36-df3627f4faa3' ? true : null,
      link_pagamento: getLocal('link_parceiro')
    }
    try {
      const { data } = await Api.post('users/create', userData);
      setUserID(data.usuario_id);
      setLocal('usuario_id', data.usuario_id);
      createRepresentante(data.usuario_id);
    } catch (error) {
      //console.log(error.response);
      toast.error('Erro ao criar usuário');
      if (error.response.status === 409)
        toast.error(error.response.data.error)
    }
    finally {
      setLoading(false);
    }
  }

  const createRepresentante = async (e) => {
    setLoading(true);
    const representanteData = {
      usuario_id: e,
      rep_legal_nome: CPF ? getLocal('nomecadastro') : nome,
      rep_legal_nome_mae: nomeMae,
      rep_legal_documento: CPF ? getLocal('documentocadastro') : unMask(documento),
      rep_legal_data_nascimento: formatISO(birthday, { representation: 'date' }),
    }
    try {
      await Api.post('representantelegal/create', representanteData);
      toast.success('Cadastro de representante legal realizado com sucesso');
      setAdress(true);
    } catch (error) {
      console.log(error);
      toast.error('Erro ao criar representante legal')
    }
    finally {
      setLoading(false);
    }
  }

  const consultaCEP = async (e) => {
    setLoading(true);
    try {
      const { data } = await Axios.get(`https://viacep.com.br/ws/${mask(e, '99999-999')}/json/`);
      if (data.erro === true) {
        //toast.error("CEP não encontrado")
        setEstado("");
        setCity("");
        setStreet("");
        setBairro("");
      }
      else {
        setEstado(data.uf);
        setCity(data.localidade);
        setStreet(data.logradouro);
        setBairro(data.bairro);
        setNumber();
        setComplemento('');
        //toast.success("CEP encontrado");
      }
    } catch (error) {
      console.log(error)
      toast.error('Serviço de verificação de CEP indisponível')
    }
    finally {
      setLoading(false);
    }
  }

  const checkZoopExistence = async () => {
    const usuario_documento = getLocal('documentocadastro')
    //console.log(usuario_documento)
    try {
      if (CPF) {
        const { data } = await ApiZoop.get(`sellers/search?taxpayer_id=${usuario_documento}`)
        return (data.id)
      }
      else {
        const { data } = await ApiZoop.get(`sellers/search?ein=${usuario_documento}`)
        return (data.id)
      }
    } catch (error) {
      console.log(error)
      return (null)
    }
  }

  const createAdress = async () => {
    setLoading(true)
    const zoop_id = await checkZoopExistence()
    //  console.log(zoop_id)
    if (zoop_id === null) {
      try {
        const { data } = await Api.post('/endereco/create', {
          endereco_cep: unMask(cep),
          endereco_estado: estado,
          endereco_cidade: city,
          endereco_bairro: bairro,
          endereco_rua: street,
          endereco_numero: number,
          endereco_complemento: complemento,
          usuario_id: userID,

        });
        setLocal('zoop_id', data.usuario_zoop_id);
        navigate('/cadastro/passo3');
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false)
      }
    } else {
      setLocal('zoop_id', zoop_id);
      navigate('/cadastro/passo3');
    }

  }

  const consultaAtividade = async () => {
    try {
      const { data } = await ApiAdimplencia('/tipoAtividade/listarTodos')
      // console.log(data)
      const atividadesArray = data.map(data => { return { label: data.tipo_atividade_descricao, value: data.tipo_atividade_id } })
      setAtividadesOptions(atividadesArray)
    } catch (error) {
      console.log(error)
    }
  }

  function handleCadastro(event) {
    event.preventDefault();
    if(rendaMensal === 0){
      return toast.error('Renda Mensal não pode ser zero, por favor informe o valor correto de sua renda mensal')
    }
    if(!atividades){
      return toast.error('Escolha uma atividade comercial')
    }
    if (!CPF) {
      if (documento.length === 14 && validaCpf(unMask(documento)))
        createUser();
      else toast.error('Insira um CPF válido!')
    } else createUser();
  }

  function handleAdressCreation(event) {
    event.preventDefault();
    createAdress()
  }

  return (
    <div className="grid overflow-auto mt-5 cadastro" >
      <div className="w-full text-center px-5">
        {/* <div className="card bg-blue-100 text-2xl text-center  md:w-1/2 w-full">
                        <h3>{getLocal('nomecadastro')}</h3>
                    </div> */}

        {!adress ? (<>
          <div className="grid gap-4 px-6">
            <ProgressBar value={25} color='#4aa677' />
            <div>
              <Tag value={getLocal('nomecadastro')}
                pt={{
                  root: classNames(
                    'bg-sky-800 hover:bg-sky-900 w-auto h-auto text-lg',
                    ' inline px-4 py-2 rounded-md',
                    'text-white'
                  )
                }}
              />
            </div>
            {!CPF ? (<>
              <div className="grid gap-2 justify-center">
                <h4>Qual a natureza jurídica da sua empresa?</h4>
                <Dropdown
                  pt={DropdownPague}
                  value={type}
                  options={options}
                  onChange={(e) => setType(e.value)}
                />
                <h4>Qual a renda mensal da sua empresa?</h4>
                <InputNumber
                  value={rendaMensal}
                  onChange={(e) => setRendaMensal(e.value)}
                  min={0}
                  pt={InputNumberPague}
                  mode='currency'
                  currency="BRL"
                />
                <h4>Qual a atividade comercial da sua empresa?</h4>
                <Dropdown
                  pt={DropdownPague}
                  value={atividades}
                  options={atividadesOptions}
                  onChange={(e) => setAtividades(e.value)}
                  placeholder="Selecione uma atividade"
                />
              </div>
              <form onSubmit={e => handleCadastro(e)}>
                <div className="grid w-full text-left gap-7">

                  <h4 className="text-xl text-center">Agora precisamos dos dados do seu representante legal</h4>
                  <FloatLabel className="grid w-full">

                    <InputText
                      id="nome"
                      className="w-full"
                      required
                      value={nome}
                      onChange={(e) => setNome(e.target.value.replace(regex, ''))}
                    />
                    <label htmlFor="nome">Nome do representante legal</label>
                  </FloatLabel>

                  <FloatLabel className="grid w-full" >

                    <InputText
                      id="nome_mae"
                      className="w-full"
                      required
                      value={nomeMae}
                      onChange={(e) => setNomeMae(e.target.value.replace(regex, ''))}
                    />
                    <label htmlFor="nome_mae">Nome da mãe do representante legal</label>
                  </FloatLabel>

                  <FloatLabel className="grid w-full" >

                    <InputText
                      id="documento"
                      className="w-full"
                      required
                      value={documento}
                      onChange={({ target }) => {
                        setDocumento(
                          mask(unMask(target.value), [
                            '999.999.999-99'
                          ])
                        )
                      }}
                    />
                    <label htmlFor="documento">CPF do representante legal</label>
                  </FloatLabel>

                  <FloatLabel className="grid w-full" pt={FloatLabelCalendar}>

                    <Calendar
                      value={birthday}
                      maxDate={today}
                      locale="pt-BR"
                      dateFormat="dd/mm/yy"
                      onChange={(e) => setBirthday(e.value)}
                      placeholder=" "
                      yearNavigator
                      yearRange="1900:2025"
                      showOnFocus={false}
                      showIcon
                      icon={<FaCalendarAlt className={
                        classNames('px-4 rounded-r-lg',
                          'w-[50px] h-full',
                          'bg-sky-400 text-white hover:bg-sky-500',
                          'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                        )}
                      />}
                      pt={CalendarPague}
                      id="datanascimento"
                      required
                      mask="99/99/9999"
                    />
                    <label className="text-sm ml-2" htmlFor="datanascimento">Data de nascimento</label>
                  </FloatLabel>

                  <div className="w-full justify-around flex">
                    <div className="w-1/3">
                      <Button
                        label="Continuar"
                        className="w-full"
                        severity="success"
                        type="submit"
                      //disabled={!aceite}
                      />
                    </div>
                    <div className="w-1/3" >
                      <Button icon={<BiRefresh className="text-2xl" />}
                        severity="danger"
                        label="Refazer"
                        className="w-full"
                        tooltip="Refazer cadastro"
                        tooltipOptions={{ position: 'bottom' }}
                        onClick={() => { localStorage.clear(); navigate('/cadastro/passo0') }} />
                    </div>
                  </div>

                </div>
              </form>
            </>) : (<>
              <div>
                {/* <h4>Qual a natureza jurídica da sua empresa?</h4>
                            <Dropdown value={type} options={options} onChange={(e)=>setType(e.value)}  /> */}
                <h4>Qual sua renda mensal?</h4>
                <InputNumber
                  value={rendaMensal}
                  onChange={(e) => setRendaMensal(e.value)}
                  min={0}
                  mode='currency'
                  currency="BRL"
                ></InputNumber>
                <h4>Qual a sua atividade comercial?</h4>
                <Dropdown
                  value={atividades}
                  options={atividadesOptions}
                  onChange={(e) => setAtividades(e.value)}
                  placeholder="Selecione uma atividade"
                />
              </div>
              <div className="cadastro-campos w-full text-center  text-xl">
                <form onSubmit={e => handleCadastro(e)}>
                  <div className="p-fluid w-full text-left">

                    <h4 className="mb-6">Agora precisamos dos seguintes dados</h4>

                    <div className="p-float-label w-full" >

                      <InputText
                        id="nome_mae"
                        required
                        value={nomeMae}
                        onChange={(e) => setNomeMae(e.target.value.replace(regex, ''))}
                      />
                      <label htmlFor="nome_mae">Nome da mãe</label>
                    </div>

                    <FloatLabel className="grid w-full" pt={FloatLabelCalendar}>

                      <Calendar
                        value={birthday}
                        maxDate={today}
                        locale="pt-BR"
                        placeholder=" "
                        dateFormat="dd/mm/yy"
                        onChange={(e) => setBirthday(e.value)}
                        yearNavigator
                        yearRange="1900:2025"
                        showOnFocus={false}
                        showIcon
                        id="datanascimento"
                        required
                        mask="99/99/9999"
                      />
                      <label htmlFor="datanascimento">Data de nascimento</label>
                    </FloatLabel>
                    <div className="w-full justify-around flex">
                      <div className="w-1/3">
                        <Button
                          label="Continuar"
                          className="w-full"
                          severity="success"
                          type="submit"
                        //disabled={!aceite}
                        />
                      </div>
                      <div className="w-1/3" >
                        <Button icon={<BiRefresh className="text-2xl" />}
                          severity="danger"
                          label="Refazer"
                          className="w-full"
                          tooltip="Refazer cadastro"
                          tooltipOptions={{ position: 'bottom' }}
                          onClick={() => { localStorage.clear(); navigate('/cadastro/passo0') }} />
                      </div>
                    </div>

                  </div>
                </form>
              </div>
            </>)}
          </div>
        </>) : (<>
          <div className="w-full gap-6 grid px-6">
            <ProgressBar value={50} color='#4aa677' />
            <div>
              <Tag value={getLocal('nomecadastro')}
                pt={{
                  root: classNames(
                    'bg-sky-800 hover:bg-sky-900 w-auto h-auto text-lg',
                    ' inline px-4 py-2 rounded-md',
                    'text-white'
                  )
                }}
              />
            </div>
            <h4 className="text-xl mb-4">Agora para prosseguir precisamos de informações do seu endereço</h4>
            <form onSubmit={e => handleAdressCreation(e)}>
              <div className="grid gap-6 w-full">

                <FloatLabel className="w-full grid">

                  <InputMask
                    value={cep}
                    className="w-full"
                    onChange={(e) => setCep(e.target.value)}
                    onComplete={(e) => consultaCEP(e.value)}
                    id="cep"
                    required
                    disabled={getLocal('cepcadastro') !== null}
                    mask="99999-999"
                  />
                  <label htmlFor="cep">CEP</label>
                </FloatLabel>

                <FloatLabel className="w-full grid">

                  <InputMask
                    value={estado}
                    className="w-full"
                    onChange={(e) => setEstado(e.target.value)}
                    id="estado"
                    required
                    type="text"
                    mask="aa"
                  />
                  <label htmlFor="estado">Estado</label>
                </FloatLabel>

                <FloatLabel className="w-full grid">

                  <InputText
                    value={city}
                    className="w-full"
                    onChange={(e) => setCity(e.target.value.replace(regexAdress, ''))}
                    id="cidade"
                    required
                    type="text"
                  />
                  <label htmlFor="cidade">Cidade</label>
                </FloatLabel>

                <FloatLabel className="w-full grid">

                  <InputText
                    value={bairro}
                    className="w-full"
                    onChange={(e) => setBairro(e.target.value.replace(regexAdress, ''))}
                    id="bairro"
                    required
                    type="text"
                  />
                  <label htmlFor="bairro">Bairro</label>
                </FloatLabel>

                <FloatLabel className="w-full grid">

                  <InputText
                    value={street}
                    className="w-full"
                    onChange={(e) => setStreet(e.target.value.replace(regexAdress, ''))}
                    id="rua"
                    required
                    type="text"
                  />
                  <label htmlFor="rua">Rua</label>
                </FloatLabel>

                <FloatLabel pt={FloatLabelNumber} className="w-full grid">

                  <InputNumber
                    value={number}
                    pt={InputNumberPague}
                    onValueChange={(e) => setNumber(e.value)}
                    id="numero"
                    required
                    min={0}
                  />
                  <label htmlFor="numero">Número</label>
                </FloatLabel>

                <FloatLabel className="w-full grid">

                  <InputText
                    value={complemento}
                    className="w-full"
                    onChange={(e) => setComplemento(e.target.value)}
                    id="complemento"
                    type="text"
                  />
                  <label htmlFor="complemento">Complemento</label>
                </FloatLabel>

                <div className="w-full justify-around flex">
                  <div className="w-1/3">
                    <Button
                      label="Continuar"
                      className="w-full"
                      severity="success"
                      type="submit"
                    //disabled={!aceite}
                    />
                  </div>
                  <div className="w-1/3" >
                    <Button icon={<BiRefresh className="text-2xl" />}
                      severity="danger"
                      label="Refazer"
                      className="w-full"
                      tooltip="Refazer cadastro"
                      tooltipOptions={{ position: 'bottom' }}
                      onClick={() => { localStorage.clear(); navigate('/cadastro/passo0') }} />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </>)}
      </div>
    </div>
  )
}

export default CadastroRepresentante